import {
  SET_ALIGNMENT_ACTIVE_PAGE, SET_ALIGNMENT_PROCESSING,
  SET_CDR_ALL_ALIGNMENTS, SET_ALL_ALIGNMENTS, SET_CDR_ALIGNMENT_PROCESSING,
  SET_CDR_ALL_ALIGNMENTS_INPUT, SET_ALIGNMENT_INFO
} from '../actions/alignment'

const defaultState = {
  isProcessing: false,
  isCDRProcessing: false,
  alignments: [],
  alignmentInfo: {},
  cdrAlignments: [],
  cdrAlignmentsInput: [],
  presumptions: [],
  activePage: 1,
  total: 0,
  project: {}
}

const Alignments = (state = defaultState, action) => {
  switch (action.type) {
    case SET_ALIGNMENT_PROCESSING:
    case SET_CDR_ALIGNMENT_PROCESSING:
    case SET_ALL_ALIGNMENTS:
    case SET_ALIGNMENT_INFO:
    case SET_CDR_ALL_ALIGNMENTS:
    case SET_CDR_ALL_ALIGNMENTS_INPUT:
    case SET_ALIGNMENT_ACTIVE_PAGE:
      return Object.assign({}, state, action.payload)
    default:
      return state
  }
}

export default Alignments